'use strict';

var React = require('react');
var Shape = require('../Components/Shape');
var Label = require('../Components/Label');
var Icon = require('../Components/Icon');
var _ = require('underscore');

var CompositeIconBase = React.createClass({
  propTypes: {
    borderVisible: React.PropTypes.bool,
    labelVisible: React.PropTypes.bool,
    alarmVisible: React.PropTypes.bool
  },

  render: function () {
    var itemProps = this.initItemProps();
    var borderVisible = this.props.borderVisible;
    var iconStyle = this.initPointStyle(itemProps.icon, 1);
    var iconBorderStyle = {};
    if (borderVisible) {
      iconBorderStyle = {
        left: itemProps.border.x,
        top: itemProps.border.y,
        width: itemProps.border.w,
        height: itemProps.border.h,
        borderColor: itemProps.border.borderColor,
        borderStyle: 'solid',
        borderWidth: itemProps.border.thickness,
        boxSizing: 'border-box',
        position: 'relative'
      };
      if (itemProps.border.shapeBorderType === 'SbEllipse') { // 圆形
        iconBorderStyle.borderRadius = '50%';
      }
    }
    return (<div className="contents-layout">
      {
        borderVisible && <div style={iconBorderStyle}></div>
      }
      <div style={iconStyle}>
        <Icon ref="icon" key="icon" {...itemProps.icon} borderVisible={false}/>
      </div>
      {
        this.props.labelVisible &&
        <div style={this.initPointStyle(itemProps.label, 2)}>
          <Label ref="label" key="label" {...itemProps.label}/>
        </div>
      }
      {
        this.props.alarmVisible &&
        <div style={this.initPointStyle(itemProps.alarm, 3)}>
          <Shape ref="alarm" key="alarm" {...itemProps.alarm} textWordWrap={false}/>
        </div>
      }
    </div>);
  },

  initItemProps: function () {
    var alarm = _.extend({}, this.props.items[3]);
    var border = _.extend({}, this.props.items[0]);
    var label = _.extend({},this.props.items[2]);
    var icon = _.extend({},this.props.items[1]);
    if(this.props.currentTextColor){
      label.currentTextColor = this.props.currentTextColor;
    }else{
      delete label.currentTextColor;
    }
    if(this.props.currentColor){
      icon.currentColor = this.props.currentColor;
    }else{
      icon.currentColor = this.props.color;
    }
    var style = this.props.style;

    alarm.radiusIsPercent = false;
    alarm.radius = alarm.h / 2;
    alarm.textSize = 12;

    if (style === 'ibsNone') {
      border.borderVisible = false;
      border.borderColor = 'transparent';
      border.color = 'transparent'
    }
    return {
      border: border,
      icon: icon,
      label: label,
      alarm: alarm
    };
  },

  initPointStyle: function (props, zIndex) {
    if (!zIndex) {
      zIndex = 0;
    }
    return {
      left: props.x,
      top: props.y,
      width: props.w,
      height: props.h,
      position: 'absolute',
      border: 'none',
      pointerEvents: 'none',
      zIndex: zIndex,
      whiteSpace: 'nowrap'
    }
  }
});

module.exports = CompositeIconBase;


// WEBPACK FOOTER //
// ./src/views/common/CompositeIconBase.jsx